import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem
} from "reactstrap"


const Header = ({ siteTitle }) => {
  // determined if page has scrolled and if the view is on mobile
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  // change state on scroll
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled);
      }
    };

    document.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      // clean up the event handler when the component unmounts
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const isActive = (path) => {
    return false;
  }    

  return ( 
      <header>
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"></link>        
        <div id="main-nav" data-active={scrolled}  className="navWrapper"></div>
        <nav className="navbar fixed-top navbar-expand-lg navbar-dark">
            <Link to="/" className="nav-brand d-flex" aria-label="Jiffy Lube Franchise home"><div className="jl-logo"></div></Link>
            <a className="skip-main" href="#main">Skip to main content</a>
            <NavbarToggler className="mr-2" onClick={toggle} />
              <Collapse isOpen={isOpen} navbar>
                <Nav navbar className="ml-auto">
                  <NavItem>
                    <Link to="/" className={isActive('/') ? "nav-link active":"nav-link"} aria-current={isActive('/') ? "page":"false"}>
                      Ready to Sell?
                    </Link></NavItem>
                  <NavItem>
                    <a href="#jl-contact-form" class="nav-link apply-now">
                        Contact Us
                    </a>
                  </NavItem>                  
                </Nav>
              </Collapse>
        </nav>
    </header>
  )
}

export default Header
